import React, { useEffect } from "react";
import * as S from "./index-styled";
import { Link } from "react-router-dom";
import { Button } from "_c/button";
import Comments from "./comments";
import Nav from "_c/modules/blog/nav";
import SEO from "./seo";
import Meta from "./meta";
import { useTranslation } from "react-i18next";
import { LinkGenerator } from "@/utils/LinkGenerator";
import PT from "prop-types";
import { useNotify } from "@/hooks/useNotify";
import { useExtractHL } from "@/hooks/useExtractHL";
import { BLOG_NS } from "@/i18n/ns";
import { FullScreenSpin as Spin } from "_c/preloader";
import { useHistory, useParams } from "react-router-dom";
import { scrollTo } from "@/utils/scroller";

const createMarkup = (content) => ({
  __html: content,
});
const ArticlePage = (props) => {
  const history = useHistory();
  const { notify, notifyError } = useNotify();
  const { t, ready } = useTranslation(["common", "errors", BLOG_NS], {
    useSuspense: false,
  });
  const { slug } = useParams();
  const hl = useExtractHL();
  const { article } = props;
  useEffect(() => {
    scrollTo(document.body);
  }, [slug]);
  const onRemove = async () => {
    try {
      await props.removeArticle(props.article._id);
      notify(t("blog:remove_success"));
      history.push(LinkGenerator.blogHome());
    } catch (e) {
      notifyError(t([`errors:${e}`, "errors:unspecified_server"]));
    }
  };
  if (!ready) {
    return <Spin size="xl" />;
  }
  if (!article) return null;
  return (
    <>
      <SEO article={article} />
      <Nav t={t} canCreateArticle={props.canCreateArticle} />
      <S.Article dangerouslySetInnerHTML={createMarkup(article.content)} />
      <Meta
        hl={hl}
        author={article.author}
        created={article.created_at}
        comments={article.comments_count}
        likes={article.likes_count}
        isAuth={props.isAuth}
        openShareModal={props.openShareModal}
        isFavorite={props.favorites.includes(props.article._id)}
        id={props.article._id}
        toggleLike={props.toggleLike}
      />
      {(props.isOwner || props.isAdmin) && (
        <S.Controls>
          <Button onClick={onRemove} negative medium>
            {t("common:remove")}
          </Button>
          <Button medium as={Link} to={LinkGenerator.blogEditor(article.slug)}>
            {t("blog:edit")}
          </Button>
        </S.Controls>
      )}
      <Comments
        removeComment={props.removeComment}
        t={t}
        isAuth={props.isAuth}
        addComment={props.addComment}
        authUserId={props.authUserId}
        comments={article.comments}
      />
    </>
  );
};
ArticlePage.propTypes = {
  article: PT.object,
  favorites: PT.array,
  isAuth: PT.bool,
  isOwner: PT.bool,
  isAdmin: PT.bool,
  authUserId: PT.string,

  openShareModal: PT.func.isRequired,
  addComment: PT.func.isRequired,
  removeComment: PT.func.isRequired,
  loadArticle: PT.func.isRequired,
  removeArticle: PT.func.isRequired,
};
export default ArticlePage;
